import { darken, lighten } from '@mui/system';
import React from 'react';

export default function GlobalStyles({ colors, customCss, font }) {
  const primaryColor = colors?.primaryColor || '#1976d2';
  const primaryContrastColor = colors?.primaryContrastColor || '#ffffff';
  const backgroundColor = colors?.backgroundColor || '#ffffff';
  const hasCustomCssFontControl = /@font-face|font-family/i.test(customCss || '');
  const regularFontName = font?.regular?.name;
  const regularFontUrl = font?.regular?.font;
  const boldFontName = font?.bold?.name;
  const boldFontUrl = font?.bold?.font;
  const regularFontFamily = regularFontName ? `${JSON.stringify(regularFontName)}, sans-serif` : null;

  const apiFontCss = hasCustomCssFontControl ? '' : `
    ${regularFontName && regularFontUrl ? `
      @font-face {
        font-family: ${JSON.stringify(regularFontName)};
        src: url('${regularFontUrl}') format('woff2');
        font-weight: 400;
        font-style: normal;
        font-display: swap;
      }
    ` : ''}
    ${boldFontName && boldFontUrl ? `
      @font-face {
        font-family: ${JSON.stringify(boldFontName)};
        src: url('${boldFontUrl}') format('woff2');
        font-weight: 700;
        font-style: normal;
        font-display: swap;
      }
    ` : ''}
    ${regularFontFamily ? `
      * {
        font-family: ${regularFontFamily}, Roboto, Helvetica, Arial, sans-serif !important;
      }
    ` : ''}
  `;

  return (

    <style>
      {customCss || ''}
      {`
        ${apiFontCss}
        html {
          --mui-palette-primary-main: ${primaryColor} !important;
          --mui-palette-primary-contrastText: ${primaryContrastColor} !important;
          --mui-palette-primary-mainChannel: ${lighten(primaryColor, 0.9)} !important;
          --mui-palette-primary-dark: ${darken(primaryColor, 0.2)} !important;
          --mui-palette-background-default: ${backgroundColor} !important;
          --template-palette-background-default: ${backgroundColor} !important;
        }
        html, body {
          background-color: ${backgroundColor} !important;
        }
      `}
    </style>
  );
}
